<template>
  <div>
    <!-- filter -->
    
    <!-- category -->
    <div class="row d-flex p-0 pb-2">
      <div class="card" >
        <div class="py-3 px-3">
          <div class="row d-flex">
            <!-- <div class="col-3 pt-3">
              <h5 class="mb-0">หมวดสินค้า</h5>                
            </div> -->
            <!-- <div class="col-3 pt-3">
              <el-checkbox v-model="filter.allCategory" @change="checkIsAllCategory" label="All" size="large" />
            </div> -->
            <div class="col-md-11">
              <span v-if="isAdmin && !$route.params.basePartnerCode">
                <el-select 
                  style="max-width:300px;" 
                  v-model="filter.partnerCode" 
                  placeholder="เลือกพาร์ทเนอร์"
                  :loading="searchingPartner"
                  clearable
                  filterable>
                  <el-option
                    v-for="partnerOption in arrPartnerOption"
                    :key="partnerOption.partnerCode"
                    :label="partnerOption.partnerName"
                    :value="partnerOption.partnerCode"                
                  >
                    <span style="float: left">{{ partnerOption.partnerCode }}</span>
                    <span
                      style="
                        float: right;
                        color: var(--el-text-color-secondary);"
                      >{{ partnerOption.partnerName }}</span
                    >
                  </el-option>
                </el-select>  
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <el-select
                    style="max-width:300px;" 
                    v-model="filter.category"
                    placeholder="หมวดสินค้า"
                    clearable
                    filterable
                >
                    <el-option v-for="c in categoryList" :key="c.code" :label="c.name" :value="c.code"></el-option>
              </el-select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              แสดงตาม {{typeView}} &nbsp;
              <el-switch
                v-model="checkType"            
                @change="handleTypeViewChange"
              >
              <!--  active-color="#13ce66"
                inactive-color="#b7b8bb"  -->
              </el-switch>
              
              <!-- <role-view :roles="['admin']"> -->
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button class="btn btn-primary btn-sm" type="submit" @click="getSellorderList('Category')">  <i class="fas fa-search fa-lg"></i> ค้นหา</button> &nbsp;&nbsp;
                
                <!-- <button class="btn btn-primary btn-sm" type="submit" @click="resetData">  <i class="fas fa-sync"></i> Reset </button> -->
              <!-- </role-view> -->
            </div>
            <div class="col-md-1 pt-5 ">
              <span  class="text-primary fint-size-small">** {{typeView}}: {{unit}} </span>
            </div>
            <!-- <div class="col-md-4">
              แสดงตาม {{typeView}} &nbsp;
              <el-switch
                v-model="type"            
                @change="handleTypeViewChange"
              >
              </el-switch>
              
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <br/> -->
    <div class="row d-flex p-0 pb-2 h-100">
      <div class="card" >
          <!-- <div class="card-header" style="min-height: 50px; padding:0rem 0rem 0rem 0.5rem"> -->
              <!-- <div class="card-title"> -->
                  <div class="row">
                    <div class="col" >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="colRShow?'Show':'Hide'"
                      >              
                        <button class="btn btn-link" @click="setColumn"><i :class="colRShow?'fa fa-indent':'fa fa-outdent'" style="cursor: pointer; font-size: 20px; color: rgb(30, 92, 158); vertical-align: middle;"></i>ขายตามหมวด {{selectedCategoryName}} </button>
                      </el-tooltip>     &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                      <!-- <div v-if="isAdmin"> -->
                        <el-popover 
                          :width="750"
                          popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
                        >
                          <template #reference>
                            <button class="btn btn-link" ><i class="fas fa-info-circle" style="cursor: pointer; font-size: 20px; color: rgb(30, 92, 158); vertical-align: middle;"></i> </button>
                          </template>
                          <template #default>
                            <div
                              class="demo-rich-conent"
                              style="display: flex; gap: 16px; flex-direction: column"
                            >
                               <h4
                                  class="demo-rich-content__name  font-weight-bold"
                                  style="margin: 0; font-weight: 800;color: rgb(30, 92, 158);"
                                >
                                <button class="btn btn-link" ><i class="fas fa-info-circle" style="cursor: pointer; font-size: 20px; color: rgb(30, 92, 158); vertical-align: middle;"></i> </button> คำอธิบายเพิ่มเติม
                              </h4>

                              <p class="demo-rich-content__desc" style="margin: 0">
                                  <strong class="text-primary">AVG3M</strong> &nbsp; ยอดขายเฉลี่ย 3 เดือนย้อนหลัง [ถึงเดือนที่แล้ว]<br/>
                                  <strong class="text-primary">Stock(วัน)</strong> &nbsp; แบ่งเป็นกรณีต่างๆดังนี้<br/>
                                  - มียอดขายเฉลี่ย 3 เดือนย้อนหลัง => (Stock/AVG3M)*30<br/>
                                  - ไม่มียอดขายเฉลี่ย 3 เดือนย้อนหลัง แต่มียอดขายปีนี้ (TY)=> (Stock/TY)*30 <br/>                      
                                  &nbsp;&nbsp;&nbsp;&nbsp;[กรณี เดือนปัจจุบันเป็นเดือนแรกของปี จะใช้ข้อมูลของปีที่แล้ว แทน TY ด้วย LY]<br/>
                                  - ไม่มียอดขายเฉลี่ย 3 เดือนย้อนหลัง ไม่มียอดขายปีนี้ (TY) และอายุสินค้ามากกว่า 30 วัน  => ระบบแสดง <span class="text-danger">DS = Death Stock</span><br/>
                                  - ไม่มียอดขายเฉลี่ย 3 เดือนย้อนหลัง ไม่มียอดขายปีนี้ (TY) และอายุสินค้าน้อยกว่า 30 วัน  => ระบบแสดง 0
                              </p>

                            </div>
                          </template>
                        </el-popover>      
                      <!-- </div>            -->
                    </div>
                  </div>
              <!-- </div> -->
          <!-- </div> -->
          <div class="row d-flex" >
          
              <div :class="colRShow?'col-md-5 p-0 ':'col-md-12 p-0'">      
                <div class="card" >          
                  <sell-order-by-category-list          
                    :data="sellOrderList.filter(
                        (data) =>
                          !filter || !filter.category
                          ||data.code.toLowerCase().includes(filter.category.toLowerCase()) 
                      )
                    "   
                    :checkType="checkType" 
                    @select="onSelectCategoryHandler"
                    :selected="selectedCategory"
                  ></sell-order-by-category-list >
                </div>              
              </div>
            
              <!-- <br/> -->
              <!-- <div  class="col-md-1"><el-divider direction="vertical" class="vertical-hr"/></div> -->
              <!-- data -->
              <!--  v-if="sellorderProduct && sellorderProduct.sellOrderSizeList" -->
              <div v-if="colRShow" class="col-md-7"> 
                <sell-order-by-product-list          
                    :selected="selectedCategory"
                    :sellorderProduct="sellorderProduct"
                    :checkType="checkType" 
                  ></sell-order-by-product-list >
              
              </div>
        </div>  
      </div>  
    </div>
    <div class="row mt-3">
        <span style="color: red;" >{{"* DS = Death Stock"}}</span>
    </div>
  </div>

</template>



<script>


import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateFromISO } from "@/utils";
import Loading from 'vue-loading-overlay';
import { validateRole, role } from "@/helpers/role"
import SellOrderByCategoryList from './SellOrderByCategoryList.vue';
import SellOrderByProductList from './SellOrderByProductList.vue';
import RoleView from '@/components/RoleView.vue';
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
    
    components: {  
      SellOrderByCategoryList,
      SellOrderByProductList,
      //RoleView
    },
    computed: {
      windowHeight() {
        return this.$store.getters.getWindowHeight
      },
      CategoryCardHeight() {
        return this.windowHeight - 250
      },
      isAdmin() {
          return validateRole(role.admin)
      },
      thisMonth(){
        var date = new Date()
        return date.getMonth()+1;
      }
    },
    data(){
        return{
            // windowHeight: window.innerHeight,
            sellOrderList: [],
            isLoadingHead: false,
            filter: {
              dateRange: [],
              partnerCode: null,
              categorie:"",
              allCategory:false
            },
            selectedCategory: null,
            selectedCategoryName:"",
            sellorderProduct:{},
            type:"piece",
            checkType:false,
            typeView:"หน่วย",
            unit:"เส้น",  
            arrPartnerOption: [],
            searchingPartner: false,
            colRShow:false
        }
    }, 
    mounted() {
        setCurrentPageBreadcrumbs("รายงานการขายตามหมวดสินค้า", ["รายงาน"])
        if(!validateRole(role.admin)){
           this.getSellorderList("Category");
        }
        this.getCategories();
        this.searchPartner("");
    },
    methods:{
      resetData(){
        this.selectedCategory=null;
        this.sellorderProduct={};
        this.type="piece";
        this.checkType=false;
        this.typeView="หน่วย";
        this.unit="เส้น";
        this.colRShow=false;
        this.filter= {
          dateRange: [],
          partnerCode: null,
          categorie:"",
          allCategory:false
        }
        if(!validateRole(role.admin)){
           this.getSellorderList("Category");
        }

      },
      setColumn(){
          if(this.colRShow){
            this.colRShow=false;
            this.selectedCategory=null;
            this.sellorderProduct={};
            
          }else{
            this.colRShow=true;
            this.selectedCategoryName = "";
          }
      },
      searchPartner: async function(query)
      {
        this.searchingPartner = true;
        const {data} = await ApiService.query("data-options/partners", {query})
        this.arrPartnerOption = data
        this.searchingPartner = false;
      }, 
      getCategories: async function () {

          try {

              const { data } = await ApiService.query(
              "reports/GetCategoryFilterList"
              );
              this.categoryList=data;
              //this.categorySummaryList = data;
              
          
          } catch (error) {
              console.log(error);
          }            

      
      },
      getSellorderList: async function (type) {
            this.isLoadingHead = true;
            this.sellorderProduct={};

            try {
              if(!validateRole(role.admin) || this.filter.partnerCode ){
                  const params = {
                    productID: 0, 
                    category: '',
                    provinceID:0,
                    branchMulti:'', 
                    productSizeID:0,
                    showColumn:type,
                    period:'',
                    partnerCode:this.filter.partnerCode         
                  
                  };
                  const { data } = await ApiService.post("Sellorder/GetSellorderList", params);
                  // data.forEach(val => {
                  //   if(this.thisMonth>1){
                  //     if(val.last3Month>0){
                  //       val.stockWeightDay =(val.stockWeight/val.last3Month)*30;  //หรือ (val.stockWeight/(val.last3Month/30))           

                  //     }else  if(val.last3Month == 0 && val.thisYear >0 ){
                  //       val.stockWeightDay =(val.stockWeight/val.thisYear)*30;        

                  //     }else  if(val.last3Month == 0 && val.thisYear ==0  && val.stockDays >30 ){
                  //       val.stockWeightDay =99999;     

                  //     }else{
                  //       val.stockWeightDay =0;
                  //     }

                  //     if(val.qLast3Month>0){
                  //       val.stockQuanDay =(val.stockQuan/val.qLast3Month)*30;  //หรือ (val.stockWeight/(val.last3Month/30))           

                  //     }else  if(val.qLast3Month == 0 && val.qThisYear >0 ){
                  //       val.stockQuanDay =(val.stockQuan/val.qThisYear)*30;        

                  //     }else  if(val.qLast3Month == 0 && val.qThisYear ==0  && val.stockDays >30 ){
                  //       val.stockQuanDay =99999;     

                  //     }else{
                  //       val.stockQuanDay =0;
                  //     }
                  //   }else{
                  //     if(val.last3Month>0){
                  //       val.stockWeightDay =(val.stockWeight/val.last3Month)*30;  //หรือ (val.stockWeight/(val.last3Month/30))           

                  //     }else  if(val.last3Month == 0 && val.lastYear >0 ){
                  //       val.stockWeightDay =(val.stockWeight/val.lastYear)*30;        

                  //     }else  if(val.last3Month == 0 && val.lastYear ==0  && val.stockDays >30 ){
                  //       val.stockWeightDay =99999;     

                  //     }else{
                  //       val.stockWeightDay =0;
                  //     }

                  //     if(val.qLast3Month>0){
                  //       val.stockQuanDay =(val.stockQuan/val.qLast3Month)*30;  //หรือ (val.stockWeight/(val.last3Month/30))           

                  //     }else  if(val.qLast3Month == 0 && val.qLastYear >0 ){
                  //       val.stockQuanDay =(val.stockQuan/val.qLastYear)*30;        

                  //     }else  if(val.qLast3Month == 0 && val.qLastYear ==0  && val.stockDays >30 ){
                  //       val.stockQuanDay =99999;     

                  //     }else{
                  //       val.stockQuanDay =0;
                  //     }
                  //   }
                   
                    
                  // });
                  this.sellOrderList = data; 
                  
              }else{
                Swal.fire("", "กรุณาระบุพาร์ทเนอร์" , "warning"); 
              }
             
            
            } catch (error) {
                console.log(error);
            }            

            this.isLoadingHead = false;
        },
        onSelectCategoryHandler: async function (category) {
          this.selectedCategory = category.code;
          this.selectedCategoryName = category.name;
          await this.getList();
        },
        // getCategoryByFilter: async function () {
        //   this.selectedCategory = this.filter.category;
        //   await this.getList();
        // },        
        getList: async function () {
          this.isLoadingHead = true;

          try {
            const params = {
              productID: 0, 
              category: this.selectedCategory,
              provinceID:0,
              branchMulti:'', 
              productSizeID:0,
              // showColumn:'',
              period:'' ,
              partnerCode:this.filter.partnerCode                
            
            };
          
            const { data } = await ApiService.post("Sellorder/GetSellorderProductList", params);
            
            if(!this.colRShow){this.colRShow=true;}
            
            this.sellorderProduct = data; 
            //console.log("this.sellorderProduct",this.sellorderProduct);
          
          } catch (error) {
              console.log(error);
          }            

          this.isLoadingHead = false;
      },
      handleTypeViewChange(){
        // console.log(this.checkType)
          if(this.checkType){
            this.type = "weight";
            this.typeView = "น้ำหนัก";
            this.unit="mt."
          }else{
            this.type = "piece";
            this.typeView = "หน่วย";
            this.unit="เส้น";
            
          }
      },
      numberWithCommas, formatDateFromISO 
    }
}
</script>
<style>
.vertical-hr {
  border-left: 1px solid #ccc;
  height: 80vh; /* Adjust the height as needed */
  margin: 0 10px; /* Add margins to create spacing */
}
</style>